import { takeLatest } from 'redux-saga/effects';
import { fetchEntitySpawn } from 'store/saga';
import URLHelper from './permissions.urls';
import {
  FETCH_USER_SEARCH_LIST,
  FETCH_USER_DETAILS,
  UPDATE_USER_DETAILS,
  CREATE_USER,
  UPDATE_USER_ROLES,
  UPDATE_USER_ODIN_PERMISSIONS,
  fetchUserSearchList,
  fetchUserDetails,
  updateUserDetails,
  createUser,
  updateUserRoles,
  updateUserPermissions,
} from './permissions.actions';
import { REQUEST } from 'utils/actionGenerator';

function* getUserSearchListSaga(action: any) {
  const request = URLHelper.getUserByEmail(action.params);
  yield fetchEntitySpawn(request, fetchUserSearchList, action.params);
}
function* getUserDetailsSaga(action: any) {
  const request = URLHelper.getUserDetails(action.params);
  yield fetchEntitySpawn(request, fetchUserDetails, action.params);
}
function* updateUserDetailsSaga(action: any) {
  const request = URLHelper.updateUserDetails(action.params);
  yield fetchEntitySpawn(request, updateUserDetails, action.params);
}
function* createUserSaga(action: any) {
  const request = URLHelper.createUser(action.params);
  yield fetchEntitySpawn(request, createUser, {
    ...action.params,
    toaster: { successMsg: 'User added successfully', errorMsg: 'Something went wrong' },
  });
}
function* updateUserRolesSaga(action: any) {
  const request = URLHelper.updateUserRoles(action.params);
  yield fetchEntitySpawn(request, updateUserRoles, action.params);
}
function* updateUserPermissionsSaga(action: any) {
  const request = URLHelper.updateUserOdinPermissions(action.params);
  yield fetchEntitySpawn(request, updateUserPermissions, {
    ...action.params,
    toaster: {
      successMsg: 'Permissions updated successfully',
      errorMsg: 'Failed to update permissions',
    },
  });
}

function* PermissionsSaga() {
  yield takeLatest(FETCH_USER_SEARCH_LIST[REQUEST], getUserSearchListSaga);
  yield takeLatest(FETCH_USER_DETAILS[REQUEST], getUserDetailsSaga);
  yield takeLatest(UPDATE_USER_DETAILS[REQUEST], updateUserDetailsSaga);
  yield takeLatest(CREATE_USER[REQUEST], createUserSaga);
  yield takeLatest(UPDATE_USER_ROLES[REQUEST], updateUserRolesSaga);
  yield takeLatest(UPDATE_USER_ODIN_PERMISSIONS[REQUEST], updateUserPermissionsSaga);
}

export default PermissionsSaga;
